module.exports = __webpack_public_path__ + "img/shopData.6aaf9cf9.png";